<div class="loading-overlay">
    <div class="loading-spinner"></div>
    <div class="maxim-logo">
        <img src="../../../../../assets/maxim-logo/m-logo.png" alt="">
    </div>
</div>